import { Form, SelectPicker } from "rsuite";
import { DateInput } from "../../components/textInput.component";
import { useAppDispatch } from "../../core/redux/ReduxStore";
import { InvoiceFilterActions, ActionsInvoiceTable } from "../../core/redux";
import { ApiPatient } from "../../core/apis/patient";
import { StorageAuth } from "../../core/localStorage";

export const InvoiceFilter = () => {
  const dispatch = useAppDispatch();

  // Get patients (similar to appointmentDataExchange implementation)
  const { data: patients } = ApiPatient.GetAllFromCompany.Hook();
  const selectedCompany = StorageAuth.CompanyId;
  const { data: insuranceTypes } = ApiPatient.GetAllInsuranceTypes.Hook(
    selectedCompany ?? ""
  );
  const patientsSelectItems =
    patients?.map((patient) => ({
      label: `${patient.firstName} ${patient.lastName}`,
      value: patient.sKey,
    })) || [];

  const insuranceTypesSelectItems =
    insuranceTypes?.map((insuranceType) => ({
      label: `${insuranceType.name}`,
      value: insuranceType.sKey,
    })) || [];

  return (
    <Form className="row g-3" fluid>
      <Form.Group className="col-md-3">
        <SelectPicker
          block
          data={insuranceTypesSelectItems}
          placeholder="Select insurance type"
          cleanable
          onChange={(value) => {
            dispatch(ActionsInvoiceTable.goToPage(1));
            dispatch(
              InvoiceFilterActions.setFilterByInsuranceType(value as string)
            );
          }}
        />
      </Form.Group>
      <Form.Group className="col-md-3">
        <SelectPicker
          block
          data={patientsSelectItems}
          placeholder="Select patient"
          cleanable
          onChange={(value) => {
            dispatch(ActionsInvoiceTable.goToPage(1));
            dispatch(InvoiceFilterActions.setFilterByPatient(value as string));
          }}
        />
      </Form.Group>

      <Form.Group className="col-md-3">
        <DateInput
          fullWidth
          placeholder="Select start date"
          onChange={(date: Date) => {
            dispatch(ActionsInvoiceTable.goToPage(1));
            dispatch(InvoiceFilterActions.setStartDate(date));
          }}
          name="start"
        />
      </Form.Group>
      <Form.Group className="col-md-3">
        <DateInput
          fullWidth
          placeholder="Select end date"
          onChange={(date: Date) => {
            dispatch(ActionsInvoiceTable.goToPage(1));
            dispatch(InvoiceFilterActions.setEndDate(date));
          }}
          name="end"
        />
      </Form.Group>
    </Form>
  );
};
